module.exports = {
	"dk": {
		"enabled": true,
		"url": "/cookies"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/cookie.json
// module id = 1205
// module chunks = 0 1